import { Repeat } from 'lucide-react';
import { ClinicalInsightData } from '../../../../../types/live-insights';

interface RecurrentPatternCardProps {
    data: ClinicalInsightData;
}

export function RecurrentPatternCard({ data }: RecurrentPatternCardProps) {
    return (
        <div className="group relative overflow-hidden rounded-xl bg-white/40 p-4 shadow-sm ring-1 ring-black/5 backdrop-blur-md transition-all hover:shadow-md hover:ring-black/10">
            {/* Soft teal accent */}
            <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-teal-400/60 to-cyan-500/60" />

            <div className="flex items-start gap-3">
                <div className="mt-1 rounded-full bg-teal-50 p-1.5 text-teal-600">
                    <Repeat className="h-4 w-4" />
                </div>
                <div className="flex-1 space-y-1">
                    <p className="text-xs leading-relaxed text-slate-600">
                        {data.content}
                    </p>
                </div>
            </div>
        </div>
    );
}
